module.exports = __webpack_public_path__ + "img/card-empresas.c01ce8ed.png";